export default __webpack_public_path__ + "static/media/chev-left.3459946b.svg";